import React from 'react';
import AlgoliaTableColumns from './TableColumns';
import AlgoliaTagsDialog from './TagsDialog';
import { AvailableColumn, AlgoliaLearnosityItem } from './types';

interface TableDialogsProps {
  isColumnSelectorOpen: boolean;
  onColumnSelectorClose: () => void;
  availableColumns: AvailableColumn[];
  selectedTagColumns: string[];
  onColumnsChange: (columns: string[]) => void;
  isTagDialogOpen: boolean;
  onTagDialogClose: () => void;
  currentHit: AlgoliaLearnosityItem | null;
}

/**
 * Component that manages the various dialogs used in the Algolia table
 */
const TableDialogs: React.FC<TableDialogsProps> = ({
  isColumnSelectorOpen,
  onColumnSelectorClose,
  availableColumns,
  selectedTagColumns,
  onColumnsChange,
  isTagDialogOpen,
  onTagDialogClose,
  currentHit,
}) => (
  <>
    <AlgoliaTableColumns
      isOpen={isColumnSelectorOpen}
      onClose={onColumnSelectorClose}
      availableColumns={availableColumns}
      selectedColumns={selectedTagColumns}
      onColumnsChange={onColumnsChange}
    />

    <AlgoliaTagsDialog
      isOpen={isTagDialogOpen}
      onClose={onTagDialogClose}
      hit={currentHit}
    />
  </>
);

export default TableDialogs;
